"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_transfer__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192 192",
    style: {
      enableBackground: "new 0 0 192 192"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{opacity:6.000000e-02;}\n\t.st3{fill:#E60000;}\n\t.st4{opacity:0.12;enable-background:new    ;}\n\t.st5{clip-path:url(#SVGID_2_);}\n\t.st6{opacity:6.000000e-02;enable-background:new    ;}\n\t.st7{opacity:0.2;fill:url(#SVGID_3_);enable-background:new    ;}\n\t.st8{clip-path:url(#SVGID_5_);}\n"), /*#__PURE__*/React.createElement("title", null, "transfer-hi"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "d156d987-488f-4f2c-a39d-15250471d30d",
    y: 0,
    className: "st0",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.9,117.5v-9.5h26.6c5.9,0,10.6-4.8,10.6-10.6c0,0,0,0,0,0V76H55.9v-9.5c0-1.5-1.2-2.7-2.7-2.7 c-0.7,0-1.4,0.3-1.9,0.8L24,92l27.4,27.4c1,1,2.7,1,3.8,0C55.6,118.9,55.9,118.2,55.9,117.5L55.9,117.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5,107.9v9.5c0,1.2-0.8,2.3-2,2.6c1.4,0.4,2.9-0.5,3.2-1.9c0,0,0,0,0,0c0.1-0.2,0.1-0.4,0.1-0.6v-9.5H54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2,107.9h1.3c5.9,0,10.6-4.8,10.6-10.6V75.9h-1.3v21.3C91.8,103.1,87,107.9,81.2,107.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5,66.4v9.6h1.3v-9.5c0-1.5-1.2-2.7-2.7-2.6c-0.2,0-0.4,0-0.6,0.1C53.7,64.1,54.5,65.2,54.5,66.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104,26.5V36H77.5c-5.9,0-10.6,4.7-10.6,10.6v21.2H104v9.5c0,1.5,1.2,2.6,2.6,2.7c0.7,0,1.4-0.3,1.9-0.8 L135.8,52l-27.3-27.3c-1-1-2.7-1-3.7,0C104.3,25.2,104,25.8,104,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.2,24.7L134.5,52l-27.3,27.2c-0.3,0.3-0.7,0.5-1.2,0.7c0.9,0.3,1.9,0,2.5-0.7L135.8,52l-27.3-27.3 c-0.6-0.7-1.6-0.9-2.5-0.7C106.4,24.1,106.8,24.3,107.2,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132,164.6v-9.4l-7.1,1.4l-3.5-1.8l12.5-2.4h5.9v12.2H132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.4,155.2c0,6.9,18.8,12.5,42.1,12.5c22.9,0,41.4-5.4,42.1-12.1v-15.7h-6v1.2c-7.4-2.3-20.8-3.9-36.1-3.9 s-28.8,1.6-36.1,3.9v-1.2h-6L78.4,155.2L78.4,155.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M78.4,155.2c0,6.9,18.9,12.5,42.1,12.5c22.8,0,41.4-5.4,42.1-12.1v-15.7h-6v1.2 c-7.4-2.3-20.8-3.9-36.1-3.9s-28.8,1.6-36.1,3.9v-1.2h-6L78.4,155.2L78.4,155.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.9,142.3v20.6c2.3,0.9,4.6,1.6,7,2.2v-22.8H81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9,142.3v25.2c2.3,0.3,4.6,0.5,7,0.7v-25.9L95.9,142.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,148.6v21.5c2.3,0.1,4.6,0.1,7,0.2v-21.7H110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,149.8v18.7c2.4,0,4.7,0,7-0.1v-18.6H124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,148.9v19.6c2.4-0.2,4.8-0.4,7-0.6v-19L138,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.1,142.7V166c2.5-0.5,4.9-1,7-1.5v-21.8H152.1z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.4,155.2c0,6.9,18.9,12.5,42.1,12.5c22.8,0,41.4-5.4,42.1-12.1v-15.7h-6v1.2c-7.4-2.3-20.8-3.9-36.1-3.9 s-28.8,1.6-36.1,3.9v-1.2h-6L78.4,155.2L78.4,155.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 120.5,
    cy: 139.6,
    rx: 42.1,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 120.5,
    cy: 139.6,
    rx: 42.1,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.5,148.1v-9.3l-7.1,1.4l-3.5-1.8v-2.5l12.5,0.1h5.9v12.2H118.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.5,148.1v-9.3l-7.1,1.4l-3.5-1.8v-2.5l12.5,0.1h5.9v12.2H118.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.5,145.5v-9.3l-7.1,1.4l-3.5-1.8l12.5-2.4h5.9v12.1H118.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 925.92,
    y1: -532.9073,
    x2: 1004.15,
    y2: -532.9073,
    gradientTransform: "matrix(1 0 0 -1 -841.54 -381.07)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M156.6,139.9v1.2c-7.4-2.3-20.8-3.9-36.1-3.9s-28.7-2.5-36.1-0.2l0.7,1.7l0.5,1l27.8,27.7 c2.3,0.1,4.8,0.2,7.2,0.2c22.8,0,41.4-5.4,42.1-12.1v-15.7L156.6,139.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.8,136.2c0,6.9,18.9,12.5,42.1,12.5c22.9,0,41.4-5.4,42.1-12.1v-15.7h-6v1.2c-7.4-2.3-20.8-3.9-36.1-3.9 s-28.8,1.6-36.1,3.9v-1.2h-6L83.8,136.2L83.8,136.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M83.8,136.2c0,6.9,18.9,12.5,42.1,12.5c22.8,0,41.4-5.4,42.1-12.1v-15.7h-6v1.2 c-7.4-2.3-20.8-3.9-36.1-3.9s-28.8,1.6-36.1,3.9v-1.2h-6L83.8,136.2L83.8,136.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.8,120.7v23.9c2.3,1,4.6,1.9,7,2.6v-26.4H90.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.8,120.7v29.1c2.3,0.3,4.6,0.6,7,0.9v-29.9L104.8,120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.8,127.9v24.9c2.3,0.1,4.7,0.2,7,0.2v-25.2H118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,129.3V151c2.4,0,4.7-0.1,7-0.1v-21.5L132.9,129.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,128.3V151c2.4-0.2,4.8-0.5,7-0.7v-22H147z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,121.1v27c2.5-0.5,4.9-1.1,7-1.8v-25.2H161z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M83.8,136.2c0,6.9,18.9,12.5,42.1,12.5c22.8,0,41.4-5.4,42.1-12.1v-15.7h-6v1.2c-7.4-2.3-20.8-3.9-36.1-3.9 s-28.8,1.6-36.1,3.9v-1.2h-6L83.8,136.2L83.8,136.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 125.9,
    cy: 120.6,
    rx: 42.1,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 125.9,
    cy: 120.6,
    rx: 35.1,
    ry: 9.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M159.3,117.8L159.3,117.8c-2.9-2.4-7.7-3.6-11.8-4.4c-4.5-0.9-9-1.5-13.6-1.7c-9.4-0.7-18.8-0.2-28.1,1.4 c-4.6,0.8-10.2,2.1-13.4,4.8l0,0c-1.4,1.1-2,2.5-1.4,3.9s2.3,2.5,4,3.3c-1.6-1.3-2.2-3-1.1-4.5c1-1.2,2.3-2.1,3.8-2.7 c4.6-2.2,10.4-3.2,15.9-3.9c3.6-0.4,7.2-0.7,10.8-0.8c3.7-0.1,7.4,0.1,11.1,0.5c5.8,0.6,11.9,1.5,17,3.5c1.8,0.6,3.5,1.6,4.9,3 c1.4,1.6,1,3.4-0.8,4.9c1.7-0.8,3.4-1.9,4-3.3S160.7,118.9,159.3,117.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M159.3,117.8L159.3,117.8c-2.9-2.4-7.7-3.6-11.8-4.4c-4.5-0.9-9-1.5-13.6-1.7c-9.4-0.7-18.8-0.2-28.1,1.4 c-4.6,0.8-10.2,2.1-13.4,4.8l0,0c-1.4,1.1-2,2.5-1.4,3.9s2.3,2.5,4,3.3c-1.6-1.3-2.2-3-1.1-4.5c1-1.2,2.3-2.1,3.8-2.7 c4.6-2.2,10.4-3.2,15.9-3.9c3.6-0.4,7.2-0.7,10.8-0.8c3.7-0.1,7.4,0.1,11.1,0.5c5.8,0.6,11.9,1.5,17,3.5c1.8,0.6,3.5,1.6,4.9,3 c1.4,1.6,1,3.4-0.8,4.9c1.7-0.8,3.4-1.9,4-3.3S160.7,118.9,159.3,117.8z"
  })));
}

var _default = ic_transfer__dark;
exports.default = _default;